module.exports = __webpack_public_path__ + "fonts/SFPRODISPLAYREGULAR.9101ead9.woff";